import {
    onMessageExtensionTrigger,
    onAddinTrigger,
    onAppBarTrigger,
    onOpenPreviewDialog,
    onOpenAboutDialog,
    onOpenAppStoreLaunchPage,
    onOpenAppStoreMessageExtension,
} from 'owa-nova-actions';
import {
    APP_STORE_MESSAGE_EXTENSION,
    APP_STORE_LAUNCH_PAGE,
} from 'owa-app-definitions/lib/data/AppStore';

import type { EntityType, EntityCommand } from 'owa-graph-schema';
import type { OwaNovaAction, OwaNovaKind } from 'owa-nova-actions';

function appStoreHandler(command: EntityCommand): OwaNovaAction<'AppStore'> | undefined {
    const appId = command.entity.entityId;
    // AppStore
    if (appId === APP_STORE_LAUNCH_PAGE) {
        return onOpenAppStoreLaunchPage;
    }
    if (appId === APP_STORE_MESSAGE_EXTENSION) {
        return onOpenAppStoreMessageExtension;
    }
    return undefined;
}

function dialogHandlers(
    command: EntityCommand
): OwaNovaAction<'AboutDialog' | 'PublicPreviewDialog'> | undefined {
    if (command.entity.action === 'info') {
        return command.entity.type === 'm365_previewdisclaimer'
            ? onOpenPreviewDialog
            : onOpenAboutDialog;
    }
    return undefined;
}

function componentHandler(
    command: EntityCommand
): OwaNovaAction<'MessageExtension' | 'AppBar' | 'AddIn'> | undefined {
    const ComponentActions = new Map<
        EntityType,
        OwaNovaAction<'AppBar' | 'MessageExtension' | 'AddIn'>
    >([
        // AppBar scenarios
        ['m365_app', onAppBarTrigger],
        ['outlook_mail', onAppBarTrigger],
        ['outlook_calendar', onAppBarTrigger],
        ['outlook_people', onAppBarTrigger],
        ['outlook_tasks', onAppBarTrigger],
        ['outlook_bookings', onAppBarTrigger],
        ['outlook_todo', onAppBarTrigger],
        ['outlook_files', onAppBarTrigger],
        ['outlook_feed', onAppBarTrigger],
        ['outlook_fileshub', onAppBarTrigger],
        ['outlook_eventify', onAppBarTrigger],
        ['office_yammer', onAppBarTrigger],
        ['office_orgexplorer', onAppBarTrigger],
        ['office_excel', onAppBarTrigger],
        ['office_word', onAppBarTrigger],
        ['office_powerpoint', onAppBarTrigger],
        ['office_onenote', onAppBarTrigger],
        // MessageExtension scenarios
        ['m365_messageextension', onMessageExtensionTrigger],
        // AddIns scenarios
        ['outlook_addin', onAddinTrigger],
    ]);

    return ComponentActions.get(command.entity.type);
}

const ParseHandlers: Array<(command: EntityCommand) => OwaNovaAction<OwaNovaKind> | undefined> = [
    // Array entry order matters, as it will try to parse in ascending order
    appStoreHandler,
    dialogHandlers,
    componentHandler,
];

export { ParseHandlers };
